import { Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Socket } from 'socket.io-client';
import { DiscusionAudio } from 'src/app/modules/calls/models/audio.model';
import { MyDevelopmentService } from 'src/app/modules/calls/services/my-development.service';
import { NapiService } from 'src/app/services/napi.service';
import {environment} from 'src/environments/environment';

@Component({
  selector: 'app-call-audio-player',
  templateUrl: './call-audio-player.component.html',
  styleUrls: ['./call-audio-player.component.scss'],
})
export class CallAudioPlayerComponent implements OnInit, OnDestroy {
  @ViewChild('player') playerRef: ElementRef<HTMLAudioElement>;

  @Input() callId: number;
  @Input() discussionAudio: DiscusionAudio;

  public audioUrl: string | null = '';
  // 'https://vl.veeam.com/media/discussion-audio/131/2025-05-16/13defbbe-5974-444f-a1d2-18ec3041eb4f.wav';

  private socket: Socket = null;
  private jobId: string | null = null;

  constructor(
    private napiService: NapiService,
    private myDevelopmentService: MyDevelopmentService,
    private ngZone: NgZone
  ) {}

  ngOnInit(): void {
    console.log('CallAudioPlayerComponent.ngOnInit');
    this.initAudio();
  }

  initAudio() {
    if (this.discussionAudio === null) {
      this.myDevelopmentService.getDiscussionAudio(String(this.callId))
        .then((res) => {
          console.log('CallAudioPlayerComponent.initAudio: discussionAudio', res);
          this.jobId = res.jobId;
          this.initWebSocket();
        });
    } else {
      if (this.discussionAudio.fileName.includes('jobId')) {
        this.jobId = this.discussionAudio.fileName.split('=')[1];
        console.log('CallAudioPlayerComponent.initAudio: jobId', this.jobId);
        this.initWebSocket();
      } else {
        this.audioUrl = `${environment.websiteUrl}/${this.discussionAudio?.fileName}`;
      }
    }
  }

  private initWebSocket() {
    this.socket = this.napiService.socket('global');

    this.socket.on('connect', () => {
      console.log('Connected');
      setTimeout(() => {
        this.socket.emit('joinToGlobal');
      });
    });

    this.socket.on('GlobalEvents', (payload) => {
      this.ngZone.run(() => {
        console.log('⏳ got GlobalEvents →', payload);
        if (payload.message === 'callDiscussionAudioLoadComplete') {
          if (payload.data.jobId === this.jobId) {
            this.audioUrl = `${environment.websiteUrl}/${payload?.data?.file?.file}`;
            console.log('audioUrl', this.audioUrl);
          }
        }
      });
    });

    this.socket.on('disconnect', () => {
      console.log('Disconnected');
    });
  }

  ngOnDestroy() {
    console.log('CallAudioPlayerComponent.ngOnDestroy: callId', this.callId);
    if (this.socket) {
      this.socket.removeAllListeners('GlobalEvents');
      this.socket.removeAllListeners('connect');
      this.socket.removeAllListeners('disconnect');

      this.socket.disconnect();
      console.log('Socket disconnected on destroy');
    }
  }

  public seekTo(seconds: number): void {
    const player = this.playerRef?.nativeElement;
    if (player) {
      player.currentTime = seconds;
      player.play();
    }
  }
}
